/* eslint-disable import/order */
import React from 'react';
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwareAdvancedRoadmapsGettingStartedRedirectRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/softwareAdvancedRoadmapsGettingStartedRedirectRoute.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { LazyPlanTimeline } from './ui/plan-timeline/index-old.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const softwareAdvancedRoadmapsGettingStartedRedirectRouteEntry: Route = createEntry(
	softwareAdvancedRoadmapsGettingStartedRedirectRoute,

	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: () => <ScreenRedirect to="/jira/plans?create-sample-plan=true" />,
		isRedirect: true,
		layout: globalLayout,
		resources: [...getNavigationResources()],

		navigation: {
			menuId: MenuIdPlans,
		},

		forPaint: [LazyAtlassianNavigation, LazyPlanTimeline],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
